import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

import Breakpoint from 'packages/kakapo-ui-kit/helpers/Breakpoint';
import { ButtonSize, IButtonProps } from 'packages/kakapo-ui-kit/types/Button';
import { paddings } from 'packages/kakapo-ui-kit/components/buttons/ButtonShared';

const style = css<IButtonProps>`
	color: ${(props) => props.theme.colors.primary};
	background-color: ${(props) => props.theme.colors.white};
	font-size: ${(props) => (props.size === ButtonSize.Small ? '13px' : '17px')};
	line-height: 1.4;
	font-weight: 700;
	font-family: inherit;
	padding: ${(props) => paddings[props.size ?? ButtonSize.Large]};
	box-sizing: border-box;
	cursor: pointer;
	border-radius: 6px;
	display: ${(props) => (props.fullWidth ? 'block' : 'inline-block')};
	width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
	transition: 150ms background-color ease-out;
	user-select: none;

	&:not(:disabled) {
		&:hover {
			color: ${(props) => props.theme.colors.white};
			background-color: ${(props) => props.theme.colors.primaryDark};
		}
	}

	@media screen and (max-width: ${Breakpoint.Small}) {
		padding: ${(props) => (props.size === ButtonSize.Small ? '5px 12px' : '8px')};
	}

	svg {
		margin-right: 5px;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

const WhiteButtonAnchor = styled.a<IButtonProps>`
	${style}
`;

export const WhiteButton = styled.button<IButtonProps>`
	${style}
`;

export const WhiteButtonLink = styled(Link)<IButtonProps>`
	${style}
`;

export default WhiteButtonAnchor;
